import { WorkItemFind, WorkItemFindResult } from '../../notification/work-item-request';
import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcWorkItemFindKey } from './rpc-work-item-find-model';

export class RpcWorkItemFindClient {
    /**
     * The work item find command.
     *
     * @param data the work item find object.
     * @return Promise<WorkItemFindResult> the promise object of work item find result.
     */
    public static workItemFind(rpc: Rpc, data: WorkItemFind): Promise<WorkItemFindResult> {
        return RpcInboundClient.call(rpc, RpcWorkItemFindKey.command, RpcWorkItemFindKey.version, data);
    }
}
